import MiniStepper from '@components/MiniStepper';
import Radio from '@components/Radio';
import Row from '@components/Row';
import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import usePriceUnit from '@hooks/item/usePriceUnit';
import { ItemOption } from '@models/item';
import useOptionControl from '@store/item/hooks/useOptionControl';
import getGlobalName from '@utils/getGlobalName';
import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import { getFormatedOptionPrice, getPricePrefix } from './utils/priceUtils';

interface Props {
    options: ItemOption[];
    optionGroupId: string;
    itemId: string;
}

function RadioOptions({ options, optionGroupId, itemId }:Props) {
    const {
        selectOption, isOptionSelected, watchOptionCount, watchOptionMaxCount,
    } = useOptionControl({ itemId });
    const { t } = useTranslation('item');
    const priceUnit = usePriceUnit();

    return (
        <Fragment>
            {options.map((option) => {
                const {
                    name, salePrice, optionId, isChangeable, maxQuantity, nameEn, nameJa,
                } = option;
                const optionName = getGlobalName({ nameEn, name, nameJa });
                const isPriceVisible = salePrice !== 0;
                const isStepperVisible = maxQuantity > 1 && isChangeable;
                return (
                    <Radio value={optionId}
                        key={option.optionId}
                        disabled={!isChangeable}
                        onChange={() => selectOption({ option, optionGroupId, amount: 1 })}
                        isSelected={isOptionSelected({ optionId, optionGroupId })}>
                        <Row justify='space-between' fullWidth>
                            <Row>
                                {optionName}
                                {isPriceVisible && (
                                    <PriceText color={colors.gray5} as='span' >
                                        {getFormatedOptionPrice(salePrice)}{priceUnit}
                                    </PriceText>
                                )}
                            </Row>
                            {isStepperVisible && (
                                <MiniStepper value={watchOptionCount(optionId, optionGroupId)}
                                    min={0}
                                    increase={() => selectOption({ option, optionGroupId, amount: 1 })}
                                    decrease={() => selectOption({ option, optionGroupId, amount: -1 })}
                                    max={watchOptionMaxCount(optionId, optionGroupId)} />
                            )}
                        </Row>
                    </Radio>
                );
            })}
        </Fragment>
    );
}

const PriceText = styled(Text)`
    margin-left: 8px;
`;

export default RadioOptions;
